import {joinURL} from 'ufo';
import {createOperationsGenerator, defineProvider} from '@nuxt/image/runtime';

const operationsGenerator = createOperationsGenerator()

export default defineProvider<{ baseURL?: string }>({
    getImage(src, {modifiers, baseURL}) {
        if (!baseURL) {
            // @ts-ignore
            baseURL = useRuntimeConfig().public.siteUrl;
        }

        const operations = [
            modifiers.width ? `w${modifiers.width}` : null,
            modifiers.format ? `.${modifiers.format}` : null,
        ].filter(Boolean).join(',');

        return {
            url: operations ? joinURL(baseURL, operations, src) : joinURL(baseURL, src),
        };
    },
});
